import { getRgObjectsOfType as s, RG_TYPE as g } from "@project-rouge/rg-core";
import { getLevelGEA as i } from "../level-metrics/index19.js";
const d = (l) => {
  let t = 0;
  const n = s(l, g.Building);
  for (const o of n) {
    const r = new Set(o.data.levels.map((e) => e.levelIndex));
    for (const e of r)
      t += i(o, e);
  }
  return t;
};
export {
  d as getGEA
};
//# sourceMappingURL=index25.js.map
